module.exports = __webpack_public_path__ + "img/thinking.9f8d9a5f.png";